export const startsWithConsecutiveZeros = (
    newValue: string,
    prevValue: string
) => {
    if (prevValue === '0') return (Number(newValue[1]) || newValue[1] === '0')
    if (prevValue === '-0') return ((Number(newValue[2]) || newValue[2] === '0'))
    return false
}
